<div [formGroup]="form">
  <!--Organisaton/ Bildungseinrichtung-->
  <div class="row">
    <!--  Name Organisation/ Bildungseinrichtung-->
    <div class="col-md-8">
      <div class="mb-3">
        <app-input *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                   [fieldId]="'referenz.organisation.name'"
                   [type]="'text'"
                   [control]="form.get('orgaName')"
                   label="Name der Organisation, der Firma oder des Hotels:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popOrgaName'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Namen der Bildungseinrichtung bzw. des Arbeitgebers ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Namen der Bildungseinrichtung bzw. des Arbeitgebers ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Namen der Bildungseinrichtung bzw. des Arbeitgebers ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Wenn es sich bei der Art der Referenz um eine Organisation/Firma, Hotel oder um einen akkreditierten Diplomaten handelt, tragen Sie hier bitte den Namen der Organisation/Firma, des Hotels oder der diplomatischen oder konsularischen Vertretung ein.</span>
          </div>
        </app-input>
        <app-input *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                   [fieldId]="'referenz.organisation.name'"
                   [type]="'text'"
                   [control]="form.get('orgaName')"
                   label="Name der Bildungseinrichtung, der Firma oder der Organisation:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popOrgaName'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Namen der Bildungseinrichtung bzw. des Arbeitgebers ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Namen der Bildungseinrichtung bzw. des Arbeitgebers ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Namen der Bildungseinrichtung bzw. des Arbeitgebers ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Wenn es sich bei der Art der Referenz um eine Organisation/Firma, Hotel oder um einen akkreditierten Diplomaten handelt, tragen Sie hier bitte den Namen der Organisation/Firma, des Hotels oder der diplomatischen oder konsularischen Vertretung ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Hotel Reservierungsnummer -->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.organisation.reservierungsnummer'"
                   [type]="'text'"
                   [control]="form.get('reservierungsnummer')"
                   label="Hotelreservierungsnummer:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popupReservierungsnummer'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Tragen Sie hier bitte die Hotelreservierungsnummer ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Tragen Sie hier bitte die Hotelreservierungsnummer ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Tragen Sie hier bitte die Hotelreservierungsnummer ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Tragen Sie hier bitte die Hotelreservierungsnummer ein.</span>
          </div>

        </app-input>
      </div>
    </div>
  </div>

  <div class="row align-items-end">
    <!--  Sitz der Organisation, Ort -->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.organisation.sitz'"
                   [type]="'text'"
                   [control]="form.get('orgaSitz')"
                   label="Sitz der Organisation, Ort:"
                   i18n-label="@@sitz-der-organisation-ort"
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popOrgaSitz'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort ein, an dem die Bildungseinrichtung/der Arbeitgeber seinen Sitz hat.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort ein, an dem die Bildungseinrichtung/der Arbeitgeber seinen Sitz hat.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort ein, an dem die Bildungseinrichtung/der Arbeitgeber seinen Sitz hat.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der Organisation, der Firma oder des Hotels ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!--  Sitz der Organisation, Land-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-select [fieldId]="'referenz.organisation.land'"
                    [control]="form.get('orgaSitzLand')"
                    label="Sitz der Organisation, Land:"
                    i18n-label="@@sitz-der-organisation-land"
                    [items]="landListItems"
                    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                    [saveLastFocusedEnabled]="true"
                    [popOverName]="'popOrgaSitzLand'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land aus, in dem die Bildungseinrichtung/der Arbeitgeber seinen Sitz hat.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land aus, in dem die Bildungseinrichtung/der Arbeitgeber seinen Sitz hat.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land aus, in dem die Bildungseinrichtung/der Arbeitgeber seinen Sitz hat.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier das Land der Organisation, der Firma oder des Hotels ein.</span>
          </div>
        </app-select>
      </div>
    </div>
    <!-- Aufgabe der Organisation-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-select [fieldId]="'referenz.organisation.wirkungsbereich'"
                    [control]="form.get('orgaAufgabe')"
                    label="Aufgabenstellung / Wirkungsbereich der Organisation:"
                    i18n-label
                    [items]="wirkungsbereichListItems"
                    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                    [saveLastFocusedEnabled]="true"
                    [popOverName]="'popOrgaAufgabe'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier den Wirkungsbereich aus.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier den Wirkungsbereich aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier den Wirkungsbereich aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Wirkungsbereich der Organisation, der Firma oder des Hotels ein.</span>
          </div>
        </app-select>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Registername der Organisation-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-select [fieldId]="'referenz.organisation.registerName'"
                    [control]="form.get('orgaRegisterName')"
                    label="Name des Registers der Organisation:"
                    i18n-label
                    [items]="registerListItems"
                    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                    [saveLastFocusedEnabled]="true"
                    [popOverName]="'popOrgaRegisterName'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier – falls bekannt/bzw. zutreffend - den Namen des Registers aus, in dem die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier – falls bekannt/bzw. zutreffend - den Namen des Registers aus, in dem die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier – falls bekannt/bzw. zutreffend - den Namen des Registers aus, in dem die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Namen des Registers der Organisation, der Firma oder des Hotels ein, in dem diese/dieses registriert ist.</span>
          </div>
        </app-select>
      </div>
    </div>
    <!-- Ort des Registers-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.organisation.registerOrt'"
                   [type]="'text'"
                   [control]="form.get('orgaRegisterOrt')"
                   label="Ort des Registers:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popOrgaRegisterOrt'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt/bzw. zutreffend -den Ort des Registers ein, an dem die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt/bzw. zutreffend -den Ort des Registers ein, an dem die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt/bzw. zutreffend -den Ort des Registers ein, an dem die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort des Registers der Organisation, der Firma oder des Hotels ein, an dem diese registriert ist.</span>
          </div>

        </app-input>
      </div>
    </div>
    <!-- Registernummer der Organisation-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.organisation.registerNummer'"
                   [type]="'text'"
                   [control]="form.get('orgaRegisternummer')"
                   label="Registernummer:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popOrgaRegisternummer'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt/bzw. zutreffend - die Registernummer ein, unter der die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt/bzw. zutreffend - die Registernummer ein, unter der die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt/bzw. zutreffend - die Registernummer ein, unter der die Bildungseinrichtung/der Arbeitgeber registriert ist.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Registernummer ein, unter der die Organisation, die Firma oder das Hotel registriert ist.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>

  <!--Person-->
  <div class="row">
    <!--Familienname-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.familienname'"
                   [type]="'text'"
                   [control]="form.get('familienname')"
                   label="Familienname:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popFamilienname'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Vorname-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.vorname'"
                   [type]="'text'"
                   [control]="form.get('vorname')"
                   label="Vorname(n):"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popVorname'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>

  <div class="row">
    <!--  Strasse-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.strasse'"
                   [type]="'text'"
                   [control]="form.get('strasse')"
                   label="Straße:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popStrasse'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der aktuellen Anschrift der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Hausnummer-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.hausnummer'"
                   [type]="'text'"
                   [control]="form.get('hausnummer')"
                   label="Hausnummer:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popHausnummer'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der aktuellen Anschrift der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>

  <div class="row">
    <!--  PLZ-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.plz'"
                   [type]="'text'"
                   [control]="form.get('plz')"
                   label="Postleitzahl:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popPlz'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
          </div>

        </app-input>
      </div>
    </div>
    <!-- Ort-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.ort'"
                   [type]="'text'"
                   [control]="form.get('ort')"
                   label="Ort:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popOrt'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der aktuellen Anschrift der Referenz ein.</span>
          </div>

        </app-input>
      </div>
    </div>
    <!-- Land-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-select [fieldId]="'referenz.ansprechpartner.anschrift.land'"
                    [control]="form.get('land')"
                    label="Land:"
                    i18n-label
                    [items]="landListItems"
                    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                    [saveLastFocusedEnabled]="true"
                    [popOverName]="'popLand'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land der Anschrift der Referenzperson oder der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land der Anschrift der Referenzperson oder der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land der Anschrift der Referenzperson oder der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier das Land der aktuellen Anschrift der Referenz ein.</span>
          </div>
        </app-select>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Telefon-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.kontaktdaten.telefon'"
                   [type]="'text'"
                   [control]="form.get('telefon')"
                   label="Telefon-/Mobilfunknummer:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popTelefon'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- E-Mail-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.kontaktdaten.email'"
                   [type]="'text'"
                   [control]="form.get('email')"
                   label="E-Mail:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popEmail'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>
</div>
